import { CommonModule } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { IonicModule } from '@ionic/angular'
import { Subject, takeUntil } from 'rxjs'
import { CookieConsentService } from '../../services/cookie-consent.service'

@Component({
  selector: 'app-cookie-consent-popup',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './cookie-consent-popup.component.html',
  styleUrls: ['./cookie-consent-popup.component.scss'],
})
export class CookieConsentPopupComponent implements OnInit, OnDestroy {
  showPopup = false
  private destroy$ = new Subject<void>()

  constructor(private cookieConsentService: CookieConsentService) {}

  ngOnInit() {
    // Don't show popup if running in an iframe (e.g., embedded shelter pets widget)
    if (window.self !== window.top) {
      this.showPopup = false
      return
    }

    // Show popup if user hasn't consented yet
    this.cookieConsentService
      .getConsentState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        // Show popup if user hasn't made any choice at all
        // User has made a choice if they have:
        // - Consented to analytics (hasConsented = true)
        // - Declined all non-necessary cookies (hasDeclined = true)
        // - Made any advertising consent choice (advertisingConsent is not undefined)
        const hasAnalyticsChoice = state.hasConsented || state.hasDeclined
        const hasAdvertisingChoice = state.advertisingConsent !== undefined
        const hasMadeAnyChoice = hasAnalyticsChoice || hasAdvertisingChoice

        this.showPopup = !hasMadeAnyChoice
      })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  /**
   * User accepts cookies
   */
  acceptCookies() {
    this.cookieConsentService.grantConsent()
    this.showPopup = false
  }

  /**
   * User declines non-necessary cookies (saves decline state, allows necessary cookies only)
   */
  declineCookies() {
    this.cookieConsentService.declineNonNecessaryCookies()
    this.showPopup = false
  }
}
